export default __webpack_public_path__ + "static/media/IMG_20220201_151704-enhance.57e499a3.jpg";